"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dogEgg = {
    name: "dog",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["d", "o", "g"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/rJRRZw7.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "1050px";
        img.style.height = "300px";
        img.style.transition = "7s all";
        img.style.position = "fixed";
        img.style.left = "-1100px";
        img.style.bottom = "calc(-50% + 320px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 7300);
    },
};
exports.default = dogEgg;
